export var internalaccessoriesObj = {
    Four_in_one_sensor: {
        isDistanceSensors: false,
        isGestureSensor: false,
        isLightSensor: false,
        isColorSensor: false,
    },
    isFour_in_one_sensor: false,

    isMic: false,
    isTemperature: false,

    // input
    isTouchZero: false,
    isTouchOne: false,
    isTouchTwo: false,

    // output
    isTouchZeroOutput: false,
    isTouchOneOutput: false,
    isTouchTwoOutput: false,

    isLeftEye: false,
    isRightEye: false,
    isbuzzer: false,

    isSmileOne: false,
    isSmileTwo: false,
    isSmileThree: false,
    isSmileFour: false,

    //klaw
    // isJoystick1: false,
    // isJoystick2: false,
    // isJoystick3: false,
    // isSwitch1: false,
    // isSwitch2: false,
    // isSwitch3: false,
    isPot1: false,
    isPot2: false,
    isPot3: false,
    isPot4: false,
    isPot5: false,
    isPot6: false,
}
console.log('Internal Accessories', internalaccessoriesObj)
